<template>
	<div class="h-screen w-full bg-[#B9BECB]">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col overflow-hidden">
					<div
						class="relative flex-1 overflow-y-auto shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[22px] box-border">
						<div class="mb-[42px] relative z-10">
							<div class="flex  mb-[20px]">
								<!-- <el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?'取消收藏':'点击收藏'" placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip> -->
								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]">
								<div v-for="(item,index) in optionsList" class="flex items-center mb-[10px] ">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px]">{{item.key}}.</label>{{item.value}}
								</div>
							</div>
						</div>
						<div class="bg-[#F5F5F5] p-[22px] box-border mb-[18px]">
							<div class="flex items-center mb-[10px]">
								<img v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
									src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
								<img v-else src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]"
									alt="" />
								<label v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
									class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>
								<label v-else
									class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
							</div>
							<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
								<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
								<label
									:class="currentUserRecord.user_answer==currentTopicInfo.answer?'text-[#68C340]':'text-[#FF0100]'">{{currentUserRecord.user_answer ||langInfo['no_answer']}}</label>
							</div>
							<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
								<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
								<label>{{currentTopicInfo.answer}}</label>
							</div>
							<div class="text-justify text-[16px]  text-[#101010] flex ">
								<label class="font-semibold  min-w-[80px] flex justify-between">
									{{langInfo.study_paper_answer_tip}}：</label>
								<div v-html="currentTopicInfo.analysis"
									class="flex-1 text-[#101010] whitespace-pre-wrap">
								</div>
							</div>
						</div>
						<!-- 	<div @click="askVisible=true"
							class="cursor-pointer relative z-10 flex items-center text-[#D86D21] text-[16px]">
							<img src="@/static/image/icon42.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
							{{langInfo.study_paper_answer_submit}}
						</div> -->
						<!-- 水印 -->
						<div class=" absolute w-full h-full top-0 left-0 bg-repeat"
							:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
						</div>
						<!-- 水印 -->
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentTopic==0?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="currentTopic==topicList.length - 1?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center  text-[14px]  text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1 h-[78vh] flex flex-col">
					<div
						class="flex-1 mb-[10px] flex flex-col shadow-01 rounded-[6px] pb-[20px] box-border  bg-white overflow-hidden">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class=" flex flex-wrap overflow-y-auto py-[20px] px-[13px] box-border ">
							<div @click="selectTopic(item,index)"
								:class="[item.userrecord&&item.userrecord.user_answer==item.answer?'bg-[#68C340] text-white':'bg-[#ff6969] text-white']"
								class="topicItem relative mb-[10px] cursor-pointer   flex items-center justify-center box-border"
								v-for="(item,index) in topicList" :key="index">
								<img v-if="item.is_user_collection==1" :src="collectActive"
									class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]" alt="" srcset="" />
								<label  class="cursor-pointer"> {{index + 1 }}</label>
							</div>
						</div>
					</div>

					<div
						class="shadow-01 mb-[10px] rounded-[6px]  pt-[26px] pb-[20px] box-border bg-white   flex flex-col items-center justify-center">
						<div class="mb-[10px] text-[#101010]">
							{{langInfo.study_report_percent}}
						</div>
						<div class="text-[20px] text-[#FF0000] font-bold">
							{{questionInfo.question_userwrong_rate}}
						</div>
					</div>


					<div @click="backStudyCenter()"
						class="shadow-01 rounded-[6px] cursor-pointer h-[56px]  bg-[#E6F2FF] text-[#3894FF] flex items-center justify-center">
						{{langInfo.phone_back}}
					</div>
				</div>
			</div>
		</div>

		<!-- 提问/纠错 -->
		<!-- <questionCorrection :askVisible="askVisible" :order_item_id="order_item_id" :id="currentTopicInfo.id"
			:title="langInfo.study_question_tip" :course_subject_id="currentTopicInfo.course_subject_id"
			@close="closeVisible">
		</questionCorrection> -->
		<!-- 提问/纠错 -->
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	import questionCorrection from '@/components/questionCorrection.vue'

	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {
			questionCorrection,
			examHeader
		},
		data() {
			return {
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username  + '@' + this.$common.currentTime()+'@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,

				title: '',
				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),

				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),
				optionsList: [],
				currentTopicInfo: {
					id: '',
					title: '',
					isCollect: false,
					isQuestion: false,
				},
				currentTopic: 0,

				topicList: [],
				askVisible: false, //疑问纠错
				identification: '',
				small_id: '',

				currentUserRecord: {
					id: '',
					user_answer: ''
				},
				type: '', //sele章节练习  userwrong错题练习  collect收藏练习
				langInfo: {},
				order_item_id: '',
				subjectId: '',

			}
		},
		mounted() {


			this.subjectId = this.$route.query.subjectId
			this.type = this.$route.query.type
			this.identification = this.$route.query.identification

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			this.getQuestionInfo()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionInfo() {
				this.$api.getQuestionPaper({

					subjectId: this.subjectId,
					type: this.type,
					identification: this.identification,
					analysis_type: 2
				}).then((res) => {
					console.log(res.data.order_item);
					this.title = res.data.chapter_name + "-" + this.langInfo.try_doing_questions

					this.questionInfo = res.data
					// is_user_collection=是否收藏0否1是
					res.data.data.forEach((item, index) => {

						item.options.forEach((itm, ind) => {
							this.$set(itm, 'isSelect', false)
						})
					})
					this.topicList = res.data.data

					this.getCurrentInfo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getCurrentInfo() {
				this.currentUserRecord = {
					id: '',
					user_answer: ''
				}

				this.currentTopicInfo = this.topicList[this.currentTopic]
				if (this.topicList[this.currentTopic].userrecord) {
					let userrecord = this.topicList[this.currentTopic].userrecord
					this.currentUserRecord = userrecord
					this.currentTopicInfo.options.forEach((item, index) => {
						if (userrecord.user_answer == item.key) {
							item.isSelect = true
						}
					})
				}

				this.optionsList = this.currentTopicInfo.options
				console.log(this.optionsList);
				this.get_user_log()
			},
			get_user_log() {
				this.$api.user_log({
					action: 'question',
					type: 6,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 上一页
			preTopic() {
				if (this.currentTopic == 0) {
					return
				}
				this.currentTopic--
				this.getCurrentInfo()
			},
			nextTopic() {
				if (this.currentTopic == this.topicList.length - 1) {
					return
				}
				this.currentTopic++
				this.getCurrentInfo()
			},
			selectTopic(item, index) {
				this.currentTopic = index

				this.getCurrentInfo()
			},
			// 返回学习中心
			backStudyCenter() {
				this.$router.go(-2);
			},
			// 收藏
			collectClick() {
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				console.log(this.currentTopicInfo.is_user_collection);
				this.topicList[this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			closeVisible() {
				this.askVisible = false
			},
			reportContinue() {

				var mode = 1
				if (this.type == 'collect') {
					mode = 2
				} else if (this.type == "userwrong") {
					mode = 3
				}

				EventBus.$emit('reportContinue', {
					small_id: this.small_id,
					order_item_id: this.questionInfo.order_item_id,
					mode: mode
				})

				this.$router.go(-3);
			}

		}
	}
</script>

<style scoped>
	
	/deep/p img {
		width: 100% !important;
	}
	
	/* ::-webkit-scrollbar {
		display: none;
	} */


	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;
	
	}
	
	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>